module.exports = "<p>\r\n  invoice-info works!\r\n</p>\r\n"